import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';

export const TableCell = styled(MuiTableCell)(({ theme, component, padding }) => {
    const base = {
        border: 'none',
        padding: padding === 'none' ? 0 : theme.spacing(1),
        verticalAlign: 'top',

        '& .MuiTypography-root': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    };

    const isHead = component === 'th';

    if (isHead) {
        return {
            ...base,
            backgroundColor: '#F7F7F4',
            color: theme.palette.text.primary,
            fontWeight: 700,
        };
    }

    return base;
});

export default TableCell;
